import { Link } from 'react-router-dom'
import SpeczeLogo from '../../assets/SpeczeLogo'

const links = {
  Product:  ['Features', 'Pricing', 'Changelog', 'Roadmap'],
  Solutions:['Documentation Engine', 'Spec Generator', 'Test Plans', 'API Docs'],
  Company:  ['About', 'Blog', 'Careers', 'Contact'],
  Legal:    ['Privacy', 'Terms', 'Security', 'Cookies'],
}

export default function Footer() {
  return (
    <footer className="bg-cosmic-900 border-t border-white/6 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <SpeczeLogo size={34} />
            <p className="text-sm text-white/40 mt-4 leading-relaxed max-w-xs">
              Turn your Git repositories into structured documentation, test plans, and business specifications.
            </p>
            <div className="flex gap-3 mt-5">
              {['github','twitter','linkedin'].map(s => (
                <a key={s} href="#" className="w-8 h-8 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-white/40 hover:text-white hover:border-purple-500/30 transition-all">
                  <span className="text-xs">{s[0].toUpperCase()}</span>
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          {Object.entries(links).map(([section, items]) => (
            <div key={section}>
              <p className="text-xs font-bold uppercase tracking-widest text-white/30 mb-4">{section}</p>
              <ul className="space-y-2.5">
                {items.map(item => (
                  <li key={item}>
                    <a href="#" className="text-sm text-white/50 hover:text-white transition-colors">{item}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="glow-divider mb-6" />
        <div className="flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/30">
          <span>© {new Date().getFullYear()} Specze. All rights reserved.</span>
          <span className="font-mono">v1.0.0 · Built with ❤️ for developers</span>
        </div>
      </div>
    </footer>
  )
}
